import React from 'react'
import useLanguagesHooks from '../Languages/setLanguage-hooks';
import styles from './fileUploader.module.scss';

interface IProps {
    handleFileInputChange: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>,
    id: string,
    buttonStyle?: string;
    buttonTitleStyle?: string;
};

const FileUploader: React.FC<IProps> = (props) => {
    const { handleFileInputChange, id, buttonStyle, buttonTitleStyle } = props;
    const { t } = useLanguagesHooks();

    return (
        <div className={`${styles.container} `}>
            <input
                id={id}
                type="file"
                accept="image/*"
                onChange={handleFileInputChange}
                style={{ display: "none" }}
            />
            <label htmlFor={id} className={`${buttonStyle} ${styles.button}`}>
                <p className={`${styles.title} ${buttonTitleStyle}`}>
                    {t('Buttons.Upload_Image')}
                </p>
            </label>
        </div>
    )
}

export default FileUploader
